import './dialog.less';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../modal';

const propTypes = {
	title: PropTypes.string.isRequired,
	body: PropTypes.string.isRequired,
	buttonSuccessText: PropTypes.string,
	buttonCancelText: PropTypes.string,
	resolve: PropTypes.func.isRequired,
	reject: PropTypes.func.isRequired
};

const defaultProps = {
	buttonSuccessText: 'Подтвердить',
	buttonCancelText: 'Отмена'
};

class Dialog extends  React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="dialog-confirm">
				<Modal
					className="dialog-confirm__wrapper modal-overlay__content"
					isOpen={true}
					title={this.props.title}
					onClose={this.props.reject}
					body={this.renderBody()} />
			</div>
		);
	}

	renderBody() {
		return (
			<div className="dialog-confirm__wrapper-body">
				<div
					className="dialog-confirm__wrapper-body-text"
					dangerouslySetInnerHTML={{__html:this.props.body}} />
				<div className="dialog-confirm__wrapper-body-btn">
					{ this.props.buttonSuccessText && (
						<button
							onClick={this.props.resolve}
							className="ui-btn ui-btn-primary">
							{ this.props.buttonSuccessText }
						</button>
					) }

					{ this.props.buttonCancelText && (
						<button
							onClick={this.props.reject}
							className="ui-btn">
							{ this.props.buttonCancelText }
						</button>
					) }
				</div>
			</div>
		);
	}
}

Dialog.propTypes = propTypes;
Dialog.defaultProps = defaultProps;

export default Dialog;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/confirm/dialog.js